const Swal = require('sweetalert2')

export default {
  methods: {
    redirectThirdSiteNotification(newUrl, text, isBlank = true) {
        Swal.fire({
            title: "IMPORTANTE",
            html: text,
            width: 600,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor: "#28DE18",
            denyButtonColor: "#3b3a3e",
            confirmButtonText: 'Continuar',
            denyButtonText: `Cancelar`,
            customClass: {
                container: 'fa-2x',
                title: 'fa-3x',
                text: 'fa-2x',
                confirmButton: 'submit__btn-btn',
                denyButton: '...',
              }
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                if(isBlank) {
                  window.open(`${newUrl}`);
                } else {
                  window.location.assign(`${newUrl}`);
                }
            } else if (result.isDenied) {
                Swal.close();
            }
          })
    }
  }
}